/**
 * Internal dependencies
 */
export { proxifyState, peek, deepMerge } from './state';
export { proxifyStore } from './store';
export { proxifyContext } from './context';
